import React, { FC, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useQueryParam } from 'use-query-params';

import Select, { SimpleOption } from 'vibo-ui/Select';

import { contactRoleFilterOptions } from '../constants';

import useStyles from '../style';

const ContactRoleFilter: FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  const [role = '', setRole] = useQueryParam<string | undefined>('role');

  const options = useMemo(
    () =>
      contactRoleFilterOptions.map(option => ({
        label: t(option.name),
        ...option,
        className: option.name,
      })),
    [contactRoleFilterOptions]
  );

  const handleChange = useCallback(option => {
    const { value } = option as SimpleOption;

    setRole(value);
  }, []);

  return (
    <Select
      value={role}
      onChange={handleChange}
      options={options}
      classNames={{
        menu: () => classes.statusMenu,
      }}
      selectedValuePrefix={t('role')}
      styleModificator="asLink"
      withCustomValueContainer
      hideDropdownIndicator
      menuShouldBlockScroll
    />
  );
};

export default ContactRoleFilter;
